"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = __importDefault(require("debug"));
var debug = (0, debug_1.default)("@staffbar/client:IFrameController");
/**
 * Manages the lifecycle of the iframe, when it's created and destroyed.
 *
 */
var IFrameController = /** @class */ (function () {
    function IFrameController(options) {
        // Public so we can publish messages to the bar
        this.iframeRef = null;
        this.spacerRef = null;
        this.options = options;
    }
    /**
     * Setup the iframe.
     */
    IFrameController.prototype.setup = function () {
        // Spacer must come before iframe
        // so the iframe is on top
        this._setupSpacer();
        this._setupIFrame();
    };
    /**
     * Cleans up the iframe.
     */
    IFrameController.prototype.cleanup = function () {
        debug("cleanup");
        if (this.iframeRef) {
            this.iframeRef.remove();
        }
        if (this.spacerRef) {
            this.spacerRef.remove();
        }
    };
    /**
     * Resizes the iframe if it exists.
     *
     * @param height The new css encoded height
     */
    IFrameController.prototype.resize = function (height) {
        if (!this.iframeRef) {
            return;
        }
        this.iframeRef.style.height = height;
    };
    /**
     * Sets up a dom element to act as a spacer for the iframe.
     *
     */
    IFrameController.prototype._setupSpacer = function () {
        debug("_setupSpacer");
        if (this.spacerRef) {
            debug("_setupSpacer: spacer already exists");
            return;
        }
        // Create a spacer div that will always map the same height as the bar
        var spacer = document.createElement("div");
        // We start the height at 0px so that the bar doesn't show up
        // until we've received the height from the bar. This prevents
        // a flash of the bar.
        spacer.style.cssText = "width: 100%; height: 0px; display: block;";
        spacer.id = "staffbar-spacer";
        // Save a reference to the spacer
        this.spacerRef = spacer;
        // Add the spacer to the page
        document.body.prepend(spacer);
    };
    /**
     * Adds the iframe to the page.
     */
    IFrameController.prototype._setupIFrame = function () {
        debug("_setupIFrame");
        if (this.iframeRef) {
            debug("_setupIFrame: iframe already exists");
            return;
        }
        // Create the iframe
        var iframe = document.createElement("iframe");
        iframe.src = this.options.url;
        // We start the height at 0px so that the bar doesn't show up
        // until we've received the height from the bar. This prevents
        // a flash of the bar.
        iframe.style.cssText =
            "width: 100%; height: " + "0px" + "; display: block;" + "position: absolute; z-index: 9999;";
        iframe.sandbox.add("allow-scripts", "allow-same-origin", "allow-popups");
        iframe.frameBorder = "0";
        iframe.src = this.options.url;
        iframe.id = "staffbar-iframe";
        // Save a reference to the iframe
        this.iframeRef = iframe;
        // Add the iframe to the page
        document.body.prepend(iframe);
    };
    return IFrameController;
}());
exports.default = IFrameController;
